import { StoreAction, XmAction } from 'store/actions';

import {
    Cms5GPlanOverview,
    CmsABTest,
    CmsAccountDataPlanCollection,
    CmsActivation,
    CmsAdditionalDevicePayment,
    CmsAddonDetails,
    CmsAddonErrors,
    CmsAddonPlans,
    CmsAgentQuickpay,
    CmsBillingAdp,
    CmsBillingCredit,
    CmsBillingExchangeInstruction,
    CmsBillingLanding,
    CmsBillingPayment,
    CmsBillingStatement,
    CmsBucketSwitch,
    CmsByodExchange,
    CmsCallFromUS,
    CmsCompatibilityCheck,
    CmsContactBar,
    CmsCore,
    CmsCountryCodingMapping,
    CmsDataDetail,
    CmsDataSaver,
    CmsDeviceCancel,
    CmsDeviceReturn,
    CmsDevices,
    CmsDeviceSuspend,
    CmsDeviceUpgrade,
    CmsErrors,
    CmsEsimActivation,
    CmsEsimDownload,
    CmsExchangeOrder,
    CmsExtendedPromos,
    CmsHop,
    CmsInternational,
    CmsInternationalCalling,
    CmsInternationalTravel,
    CmsLevelMoveEligibility,
    CmsLevelMoveError,
    CmsLevelMoveInProgress,
    CmsLevelMovePending,
    CmsLevelMoveStart,
    CmsLevelMoveSuccess,
    CmsLineDataPlanCollection,
    CmsLineTransfer,
    CmsLogin,
    CmsMyAccount,
    CmsMyAccountModals,
    CmsNonXfinityCustomer,
    CmsOneTimePasscode,
    CmsOneTimePayment,
    CmsOrderDetail,
    CmsPlanSwitch,
    CmsQuickpayBreadcrumbs,
    CmsQuickpayErrors,
    CmsRetryPayment,
    CmsReturnOrder,
    CmsSettings,
    CmsSimSwap,
    CmsStatementList,
    CmsTradeInDevice,
    CmsTravelRates,
    CmsUsageDetail,
    CmsUserQuickpay,
    CmsVideoResolution,
    CmsXmbComingSoon
} from './models';
import { CmsEsim } from './models/esim';

export function cmsCoreReducer(state: CmsCore, action: XmAction<CmsCore>): CmsCore {
    return action.type === StoreAction.GET_CORE ? action.payload : state;
}

/** My Account Billing */

export function cmsBillingLandingReducer(state: CmsBillingLanding, action: XmAction<CmsBillingLanding>): CmsBillingLanding {
    return action.type === StoreAction.GET_BILLING_LANDING ? action.payload : state;
}

export function cmsBillingAdpReducer(state: CmsBillingAdp, action: XmAction<CmsBillingAdp>): CmsBillingAdp {
    return action.type === StoreAction.GET_BILLING_ADP ? action.payload : state;
}

export function cmsBillingCreditReducer(state: CmsBillingCredit, action: XmAction<CmsBillingCredit>): CmsBillingCredit {
    return action.type === StoreAction.GET_BILLING_CREDIT ? action.payload : state;
}

export function cmsBillingPaymentReducer(state: CmsBillingPayment, action: XmAction<CmsBillingPayment>): CmsBillingPayment {
    return action.type === StoreAction.GET_BILLING_PAYMENT ? action.payload : state;
}

export function cmsBillingStatementReducer(state: CmsBillingStatement, action: XmAction<CmsBillingStatement>): CmsBillingStatement {
    return action.type === StoreAction.GET_BILLING_STATEMENT ? action.payload : state;
}

export function cmsBillingExchangeInstructionReducer(state: CmsBillingExchangeInstruction, action: XmAction<CmsBillingExchangeInstruction>): CmsBillingExchangeInstruction {
    return action.type === StoreAction.GET_BILLING_EXCHANGE_INSTRUCTION ? action.payload : state;
}

export function cmsUsageDetailReducer(state: CmsUsageDetail, action: XmAction<CmsUsageDetail>): CmsUsageDetail {
    return action.type === StoreAction.GET_CMS_USAGE_DETAIL ? action.payload : state;
}

export function cmsReturnOrderReducer(state: CmsReturnOrder, action: XmAction<CmsReturnOrder>): CmsReturnOrder {
    return action.type === StoreAction.GET_RETURN_ORDER ? action.payload : state;
}

export function cmsExchangeOrderReducer(state: CmsExchangeOrder, action: XmAction<CmsExchangeOrder>): CmsExchangeOrder {
    return action.type === StoreAction.GET_EXCHANGE_ORDER ? action.payload : state;
}

export function cmsOrderDetailReducer(state: CmsOrderDetail, action: XmAction<CmsOrderDetail>): CmsOrderDetail {
    return action.type === StoreAction.GET_CMS_ORDER_DETAIL ? action.payload : state;
}

export function cmsDevicesReducer(state: CmsDevices, action: XmAction<CmsDevices>): CmsDevices {
    return action.type === StoreAction.GET_DEVICES ? action.payload : state;
}

export function cmsDeviceReturnReducer(state: CmsDeviceReturn, action: XmAction<CmsDeviceReturn>): CmsDeviceReturn {
    return action.type === StoreAction.GET_DEVICE_RETURN ? action.payload : state;
}

export function cmsDeviceUpgradeReducer(state: CmsDeviceUpgrade, action: XmAction<CmsDeviceUpgrade>): CmsDeviceUpgrade {
    return action.type === StoreAction.GET_DEVICE_UPGRADE ? action.payload : state;
}

export function cmsDeviceSuspendReducer(state: CmsDeviceSuspend, action: XmAction<CmsDeviceSuspend>): CmsDeviceSuspend {
    return action.type === StoreAction.GET_DEVICE_SUSPEND ? action.payload : state;
}

export function cmsDeviceCancelReducer(state: CmsDeviceCancel, action: XmAction<CmsDeviceCancel>): CmsDeviceCancel {
    return action.type === StoreAction.GET_DEVICE_CANCEL ? action.payload : state;
}

export function cmsDeviceEsimDownloadReducer(state: CmsEsimDownload, action: XmAction<CmsEsimDownload>): CmsEsimDownload {
    return action.type === StoreAction.GET_DEVICE_ESIM_DOWNLOAD ? action.payload : state;
}

export function cmsDevicePasscodeReducer(state: CmsOneTimePasscode, action: XmAction<CmsOneTimePasscode>): CmsOneTimePasscode {
    return action.type === StoreAction.GET_CMS_PASSCODE_ENTRY ? action.payload : state;
}

export function cmsErrorsReducer(state: CmsErrors, action: XmAction<CmsErrors>): CmsErrors {
    return action.type === StoreAction.GET_ERRORS ? action.payload : state;
}

export function cmsActivationReducer(state: CmsActivation, action: XmAction<CmsActivation>): CmsActivation {
    return action.type === StoreAction.GET_ACTIVATION ? action.payload : state;
}

export function cmsEsimActivationReducer(state: CmsEsimActivation, action: XmAction<CmsEsimActivation>): CmsEsimActivation {
    return action.type === StoreAction.GET_ESIM_ACTIVATION ? action.payload : state;
}

export function cmsUserQuickpayReducer(state: CmsUserQuickpay, action: XmAction<CmsUserQuickpay>): CmsUserQuickpay {
    return action.type === StoreAction.GET_CMS_USER_QUICKPAY ? action.payload : state;
}

export function cmsAgentQuickpayReducer(state: CmsAgentQuickpay, action: XmAction<CmsAgentQuickpay>): CmsAgentQuickpay {
    return action.type === StoreAction.GET_CMS_AGENT_QUICKPAY ? action.payload : state;
}

export function cmsQuickpayErrorsReducer(state: CmsQuickpayErrors, action: XmAction<CmsQuickpayErrors>): CmsQuickpayErrors {
    return action.type === StoreAction.GET_CMS_QUICKPAY_ERRORS ? action.payload : state;
}

export function cmsQuickpayBreadcrumbsReducer(state: CmsQuickpayBreadcrumbs, action: XmAction<CmsQuickpayBreadcrumbs>): CmsQuickpayBreadcrumbs {
    return action.type === StoreAction.GET_CMS_QUICKPAY_BREADCRUMBS ? action.payload : state;
}

export function cmsInternationalReducer(state: CmsInternational, action: XmAction<CmsInternational>): CmsInternational {
    return action.type === StoreAction.GET_INTERNATIONAL ? action.payload : state;
}

export function cmsLoginReducer(state: CmsLogin, action: XmAction<CmsLogin>): CmsLogin {
    return action.type === StoreAction.GET_LOGIN ? action.payload : state;
}

export function cmsHopReducer(state: CmsHop, action: XmAction<CmsHop>): CmsHop {
    return action.type === StoreAction.GET_HOP ? action.payload : state;
}

export function cmsSettingsReducer(state: CmsSettings, action: XmAction<CmsSettings>): CmsSettings {
    return action.type === StoreAction.GET_SETTINGS ? action.payload : state;
}

export function cms5GPlanOverviewReducer(state: Cms5GPlanOverview, action: XmAction<Cms5GPlanOverview>): Cms5GPlanOverview {
    return action.type === StoreAction.GET_5G_PLAN_OVERVIEW ? action.payload : state;
}

export function cmsLevelMoveStartReducer(state: CmsLevelMoveStart, action: XmAction<CmsLevelMoveStart>): CmsLevelMoveStart {
    return action.type === StoreAction.GET_LEVEL_MOVE_START ? action.payload : state;
}

export function cmsLevelMoveEligibilityReducer(state: CmsLevelMoveEligibility, action: XmAction<CmsLevelMoveEligibility>): CmsLevelMoveEligibility {
    return action.type === StoreAction.GET_LEVEL_MOVE_ELIGIBILITY_CMS ? action.payload : state;
}

export function cmsLevelMoveInProgressReducer(state: CmsLevelMoveInProgress, action: XmAction<CmsLevelMoveInProgress>): CmsLevelMoveInProgress {
    return action.type === StoreAction.GET_LEVEL_MOVE_IN_PROGRESS_CMS ? action.payload : state;
}

export function cmsLevelMoveSuccessReducer(state: CmsLevelMoveSuccess, action: XmAction<CmsLevelMoveSuccess>): CmsLevelMoveSuccess {
    return action.type === StoreAction.GET_LEVEL_MOVE_SUCCESS_CMS ? action.payload : state;
}

export function cmsLevelMovePendingReducer(state: CmsLevelMovePending, action: XmAction<CmsLevelMovePending>): CmsLevelMovePending {
    return action.type === StoreAction.GET_LEVEL_MOVE_PENDING_CMS ? action.payload : state;
}

export function cmsLevelMoveErrorReducer(state: CmsLevelMoveError, action: XmAction<CmsLevelMoveError>): CmsLevelMoveError {
    return action.type === StoreAction.GET_LEVEL_MOVE_ERROR_CMS ? action.payload : state;
}

export function cmsDataDetailReducer(state: CmsDataDetail, action: XmAction<CmsDataDetail>): CmsDataDetail {
    return action.type === StoreAction.GET_DATA_DETAIL ? action.payload : state;
}

export function cmsAccountDataPlanCollectionReducer(state: CmsAccountDataPlanCollection, action: XmAction<CmsAccountDataPlanCollection>): CmsAccountDataPlanCollection {
    return action.type === StoreAction.GET_ACCOUNT_DATA_PLAN ? action.payload : state;
}

export function cmsLineDataPlanCollectionReducer(state: CmsLineDataPlanCollection, action: XmAction<CmsLineDataPlanCollection>): CmsLineDataPlanCollection {
    return action.type === StoreAction.GET_LINE_DATA_PLAN ? action.payload : state;
}

export function cmsPlanSwitchReducer(state: CmsPlanSwitch, action: XmAction<CmsPlanSwitch>): CmsPlanSwitch {
    return action.type === StoreAction.GET_PLAN_SWITCH ? action.payload : state;
}

export function cmsBucketSwitchReducer(state: CmsBucketSwitch, action: XmAction<CmsBucketSwitch>): CmsBucketSwitch {
    return action.type === StoreAction.GET_BUCKET_SWITCH ? action.payload : state;
}

export function cmsAddonPlansReducer(state: CmsAddonPlans, action: XmAction<CmsAddonPlans>): CmsAddonPlans {
    return action.type === StoreAction.GET_ADDONS_PLANS ? action.payload : state;
}

export function cmsInternationalTravelReducer(state: CmsInternationalTravel, action: XmAction<CmsInternationalTravel>): CmsInternationalTravel {
    return action.type === StoreAction.GET_CMS_INTERNATIONAL_TRAVEL ? action.payload : state;
}

export function cmsInternationalCallingReducer(state: CmsInternationalCalling, action: XmAction<CmsInternationalCalling>): CmsInternationalCalling {
    return action.type === StoreAction.GET_CMS_INTERNATIONAL_CALLING ? action.payload : state;
}

export function cmsCallFromUSReducer(state: CmsCallFromUS, action: XmAction<CmsCallFromUS>): CmsCallFromUS {
    return action.type === StoreAction.GET_CMS_CALL_FROM_US ? action.payload : state;
}

export function cmsAddonDetailsReducer(state: CmsAddonDetails, action: XmAction<CmsAddonDetails>): CmsAddonDetails {
    return action.type === StoreAction.GET_ADDONS_DETAILS ? action.payload : state;
}

export function cmsAddonErrorsReducer(state: CmsAddonErrors, action: XmAction<CmsAddonErrors>): CmsAddonErrors {
    return action.type === StoreAction.GET_ADDON_ERRORS ? action.payload : state;
}

export function cmsMyAccountReducer(state: CmsMyAccount, action: XmAction<CmsMyAccount>): CmsMyAccount {
    return action.type === StoreAction.GET_MY_ACCOUNT ? action.payload : state;
}

export function cmsMyAccountModalsReducer(state: CmsMyAccountModals, action: XmAction<CmsMyAccountModals>): CmsMyAccountModals {
    return action.type === StoreAction.GET_MY_ACCOUNT_MODALS ? action.payload : state;
}

export function cmsContactBarReducer(state: CmsContactBar, action: XmAction<CmsContactBar>): CmsContactBar {
    return action.type === StoreAction.GET_CONTACT_BAR ? action.payload : state;
}

export function cmsABTestReducer(state: CmsABTest, action: XmAction<CmsABTest>): CmsABTest {
    return action.type === StoreAction.GET_AB_TEST ? action.payload : state;
}

export function cmsOneTimePaymentReducer(state: CmsOneTimePayment, action: XmAction<CmsOneTimePayment>): CmsOneTimePayment {
    return action.type === StoreAction.GET_ONE_TIME_PAYMENT_CMS ? action.payload : state;
}

export function cmsStatementListReducer(state: CmsStatementList, action: XmAction<CmsStatementList>): CmsStatementList {
    return action.type === StoreAction.GET_CMS_STATEMENT_LIST ? action.payload : state;
}

export function cmsAdditionalDevicePaymentReducer(state: CmsAdditionalDevicePayment, action: XmAction<CmsAdditionalDevicePayment>): CmsAdditionalDevicePayment {
    return action.type === StoreAction.GET_ADDITIONAL_DEVICE_PAYMENT_CMS ? action.payload : state;
}

// XMB Coming Soon Page
export function cmsXmbComingSoonReducer(state: CmsXmbComingSoon, action: XmAction<CmsXmbComingSoon>): CmsXmbComingSoon {
    return action.type === StoreAction.GET_CMS_XMB_COMING_SOON ? action.payload : state;
}

export function cmsnonXfinityCustomerReducer(state: CmsNonXfinityCustomer, action: XmAction<CmsNonXfinityCustomer>): CmsNonXfinityCustomer {
    return action.type === StoreAction.GET_CMS_NON_XFINITY_CUSTOMER ? action.payload : state;
}
export function cmsRetryPaymentReducer(state: CmsRetryPayment, action: XmAction<CmsRetryPayment>): CmsRetryPayment {
    return action.type === StoreAction.GET_RETRY_PAYMENT_CMS ? action.payload : state;
}

export function cmsDataSaverReducer(state: CmsDataSaver, action: XmAction<CmsDataSaver>): CmsDataSaver {
    return action.type === StoreAction.GET_CMS_DATA_SAVER ? action.payload : state;
}

export function cmsExtendedPromosReducer(state: CmsExtendedPromos, action: XmAction<CmsExtendedPromos>): CmsExtendedPromos {
    return action.type === StoreAction.GET_EXTENDED_PROMOS ? action.payload : state;
}

export function cmsSimSwapReducer(state: CmsSimSwap, action: XmAction<CmsSimSwap>): CmsSimSwap {
    return action.type === StoreAction.GET_CMS_SIM_SWAP ? action.payload : state;
}

export function cmsByodExchangeReducer(state: CmsByodExchange, action: XmAction<CmsByodExchange>): CmsByodExchange {
    return action.type === StoreAction.GET_CMS_BYOD_EXCHANGE ? action.payload : state;
}

export function cmsCountryCodingMappingReducer(state: CmsCountryCodingMapping, action: XmAction<CmsCountryCodingMapping>): CmsCountryCodingMapping {
    return action.type === StoreAction.GET_CMS_COUNTRY_CODE_MAPPING ? action.payload : state;
}

export function cmsTravelRatesReducer(state: CmsTravelRates, action: XmAction<CmsTravelRates>): CmsTravelRates {
    return action.type === StoreAction.GET_CMS_TRAVEL_RATES ? action.payload : state;
}

export function CmsLineTransferReducer(state: CmsLineTransfer, action: XmAction<CmsLineTransfer>): CmsLineTransfer {
    return action.type === StoreAction.GET_CMS_LINE_TRANSFER ? action.payload : state;
}

export function cmsCompatibilityCheckReducer(state: CmsCompatibilityCheck, action: XmAction<CmsCompatibilityCheck>): CmsCompatibilityCheck {
    return action.type === StoreAction.GET_CMS_COMPATIBILITY_CHECK ? action.payload : state;
}

export function cmsTradeInDeviceReducer(state: CmsTradeInDevice, action: XmAction<CmsTradeInDevice>): CmsTradeInDevice {
    return action.type === StoreAction.GET_CMS_TRADE_IN_DEVICE ? action.payload : state;
}

export function cmsVideoResolutionReducer(state: CmsVideoResolution, action: XmAction<CmsVideoResolution>): CmsVideoResolution {
    return action.type === StoreAction.GET_CMS_VIDEO_RESOLUTION ? action.payload : state;
}

export function CmsEsimReducer(state: CmsEsim, action: XmAction<CmsEsim>): CmsEsim {
    return action.type === StoreAction.GET_CMS_ESIM ? action.payload : state;
}
